export default new (class Address {
   constructor() {
      this.xlsTemplate = "https://d2j8p5q8vpyg6j.cloudfront.net/_template.xlsx";
      this.CEP = {
         app_key: "gwQWn49MwORMMQTx15vtzQ2yKRiYbN8O",
         app_secret: "ACafAgTIjqfSQUlBJzvLG7LBClqYilgsliYqzrcYloyYqOwp"
      };
   }
})();
